module.exports = __webpack_public_path__ + "img/23f7800.png";